export default __webpack_public_path__ + "static/media/STARS.22b05740.png";